import {
  Button,
  Container,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Image,
  Alert,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import EmptyFullHeight from "../../layouts/EmptyFullHeight";
import CardForm from "../../components/CardForm";
import CardFormTitle from "../../components/CardForm/CardFormTitle";
import { useAppDispatch } from "../../redux/store";
import { setIsLogin, setMe } from "../../redux/reducers/auth";
import { IFormData } from "./interface";
import { useLoginMutation } from "../../generated/graphql";
import { useState } from "react";

const Login = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormData>();

  const [login, { loading }] = useLoginMutation();

  const [error, setError] = useState("");

  const dispatch = useAppDispatch();

  const onSubmit = async (formData: IFormData) => {
    const { email, password } = formData;

    try {
      const { data } = await login({
        variables: { input: { email, password } },
      });

      dispatch(setMe(data?.login));
      dispatch(setIsLogin(true));
    } catch (e: any) {
      if (e.message === "invalid_credentials") {
        setError("Email or Password is not found!");
      } else {
        setError("Error!");
      }
    }
  };

  return (
    <EmptyFullHeight bgColor="#f3f4f6">
      <Container maxW="420px">
        <Image src="/images/logo.png" mb="5" borderRadius="md" />
        <CardForm>
          <CardFormTitle py={6}>Sign In</CardFormTitle>
          {error && (
            <Alert status="error" mb={5}>
              {error}
            </Alert>
          )}
          <form onSubmit={handleSubmit(onSubmit)}>
            <FormControl isInvalid={errors.hasOwnProperty("email")}>
              <FormLabel htmlFor="email">Email</FormLabel>
              <Input
                className="form-control"
                id="email"
                placeholder="Enter your email"
                {...register("email", {
                  required: true,
                })}
              />
              {errors?.email?.type === "pattern" ? (
                <FormErrorMessage className="d-block">
                  Wrong email format!
                </FormErrorMessage>
              ) : errors?.email?.type === "required" ? (
                <FormErrorMessage>Email is required!</FormErrorMessage>
              ) : (
                <></>
              )}
            </FormControl>

            <FormControl isInvalid={errors.hasOwnProperty("password")}>
              <FormLabel htmlFor="password">Password</FormLabel>
              <Input
                type="password"
                id="password"
                placeholder="Enter your password"
                {...register("password", { required: true, minLength: 6 })}
              />
              {errors?.password?.type === "minLength" ? (
                <FormErrorMessage className="d-block">
                  Password should has 6 chars minimum!
                </FormErrorMessage>
              ) : errors?.password?.type === "required" ? (
                <FormErrorMessage>Password is required!</FormErrorMessage>
              ) : (
                <></>
              )}
            </FormControl>

            <Button type="submit" w="100%" isLoading={loading}>
              Sign In
            </Button>
          </form>
        </CardForm>
      </Container>
    </EmptyFullHeight>
  );
};

export default Login;
